import en from './en.json';
import tr from './tr.json'

export default {
  en: { translation: en },
  tr: { translation: tr },
};